import { combineReducers } from '@reduxjs/toolkit';

import BimehNamehMadaniDetailSlice from '../../Detail/Actions/reducer';
import elhaghiyehHayeSaderehSlice from '../../ElhaghiyehHayeSadereh/Actions/reducer';
import masooliatMadaniEstelamAndSodoorSlice from '../../Estelam/Actions/reducer';

export const asansourReducers = combineReducers({
  estelam: masooliatMadaniEstelamAndSodoorSlice,
  bimehNamehDetail: BimehNamehMadaniDetailSlice,
  elhaghiyehHayeSadereh: elhaghiyehHayeSaderehSlice,
});
